const getters = {
  /*背景图片*/
  bgImg: state => state.bgImg.bgImg, //背景图片

  /*首页数据*/
  topLogo: state => state.souye.topLogo, //首页公司图片
  homeImg1: state => state.souye.homeImg1, //首页大图1
  homeTitle: state => state.souye.homeTitle, //首页大图1-标题
  homeImg2: state => state.souye.homeImg2, //首页大图2
  homeCaseList: state => { return state.caseList.caseList.filter((item, i) =>  i < 7) }, //首页大图2-经典案例
  homeImg3: state => state.souye.homeImg3, //首页大图3
  homeNewsList: state => { return state.newsList.companyNewsList.filter((item, i) =>  i < 3) }, //首页大图3-最新资讯

  /*经典案例*/
  caseList: state => state.caseList.caseList,

  /*新闻资讯*/
  newsList: state => [...state.newsList.companyNewsList, ...state.newsList.latestNewsList],
  companyNewsList: state => state.newsList.companyNewsList, //公司新闻
  latestNewsList: state => state.newsList.latestNewsList, //最新资讯

  /*产品中心*/
  productList: state => state.productList.productList, //产品信息

  /*公司介绍*/
  companyInfo: state => state.companyProfile.companyInfo, //公司简介
  courseInfo: state => state.companyProfile.courseInfo, //发展历程
  cultureInfo: state => state.companyProfile.cultureInfo, //企业文化
  honorList: state => state.companyProfile.honorList, //公司荣誉
  teamItem: state => state.companyProfile.teamItem, //车间风采
  partnerImg: state => state.companyProfile.partnerImg, //合作伙伴
}
export default getters